import React, { Component } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "react-animated-router/animate.css";
import { routes } from "./routes/routes";
import styles from "./App.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import   "./utils/tool.jsx";
import { AuthProvider } from "./providers/authProvider";
import { PrivateRoute } from "./routes/privateRoute";

export const authRoutes = (
    <Switch>
        {routes.map((route, index) => {
            if (!!route.login) {
                return <PrivateRoute
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={(props) => (
                        <ErrorBoundary>{route.main(props)}</ErrorBoundary>
                    )}
                />
            }
            else {
                return <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    render={(props) => (
                        <ErrorBoundary>{route.main(props)}</ErrorBoundary>
                    )}
                />
            }
        })}
    </Switch>
);

class App extends Component {

    render() {
        return (
            <AuthProvider>
                <div className={styles.container}>
                    <Router children={authRoutes} basename={"/"} />
                </div>
            </AuthProvider>
        );
    }
}

export default App;